/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import numeral from 'numeral'

export function WholeNumberWithComma(number){
    return numeral(number).format('0,0');
}